import React, { useContext } from 'react'
import { Text } from 'react-native-web';

import { Link } from 'react-router-dom'

import MuiBottomNavigationAction from "@mui/material/BottomNavigationAction";
import BottomNavigation from '@mui/material/BottomNavigation'
import styled from '@mui/material/styles/styled'
import HomeIcon from '@mui/icons-material/Home'
import StoreIcon from '@mui/icons-material/Store'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import AccountBoxIcon from '@mui/icons-material/AccountBox'

import constants from '../constants'
import MyContext from './MyContext';

const { PRIMARY, NAVBAR_HEIGHT, PATH } = constants

const BottomNavigationAction = styled(MuiBottomNavigationAction)(`
  color: #ddd;
  background-color: ${PRIMARY};
  height: ${NAVBAR_HEIGHT};
  &.Mui-selected {
    color: #fff;
  }
`)

export default function BottomNav({ route, setRoute }) {
	const { cart, tr } = useContext(MyContext)
	const w = cart.wrap

	return (
		<BottomNavigation
			showLabels
			value={route}
			onChange={(event, newValue) => {
				setRoute(newValue)
			}}
		>
			<BottomNavigationAction component={Link} to={PATH.HOME} label={tr('Home')} icon={<HomeIcon />} />
			<BottomNavigationAction component={Link} to={PATH.COMING_SOON} label={tr('Store')} icon={<StoreIcon />} />
			<BottomNavigationAction component={Link} to={PATH.CART} label={tr('Cart')} icon={w(<ShoppingCartIcon />, 1, '20%')} />
			<BottomNavigationAction component={Link} to={PATH.PROFILE} label={tr('Profile')} icon={<AccountBoxIcon />} />
		</BottomNavigation>
	)
}
